import styled from "styled-components";
export const UserDataContainer = styled.div`
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  padding: 32px;
  margin: 16px 0;
  position: relative;
  .edit-icon {
    font-size: 24px;
    position: absolute;
    top: 16px;
    left: 16px;
    cursor: pointer;
    color: #222;
  }
  .item {
    span {
      display: block;
      &:first-child {
        color: ${({ theme }) => theme.colors.lightFont};
        font-size: ${({ theme }) => theme.sizes.fontsm};
      }
      &:last-child {
        color: ${({ theme }) => theme.colors.font};
        font-size: ${({ theme }) => theme.sizes.font};
        font-weight: bold;
      }
    }
  }
`;
